/**
 * A tiny subsystem exposing the simulation's spawn helper to other subsystems.
 *
 * Subsystems reach each other only through `ctx.get(id)` (ARCHITECTURE.md §2),
 * and `build.ts` needs to create entities from registry definitions. Rather
 * than duplicating that logic or importing `sim/index.ts` — which would make
 * the module graph cyclic — the facade registers this bridge.
 */

import type { Subsystem } from '../core/registry.js'

export class SimBridge implements Subsystem {
  static id = 'sim'

  constructor(
    readonly spawnDef: (kind: number, owner: number, cx: number, cy: number) => number,
    readonly finishMatch: (status: number, winner: number) => void,
    /** Match settings that change simulation rules. See `MatchDefinition`. */
    readonly instantBuild = false,
  ) {}

  init(): void {
    // Nothing to acquire; present so the class satisfies Subsystem.
  }
}
